import type {SuggestObject} from '@yandex-delivery/api/model/suggest'
import type {Optional} from '@yandex-delivery/types'
import {
  firstOf,
  flow,
  makeGet,
  merge,
  pipe,
  toDefaultEmptyString,
} from '@yandex-delivery/utils'
import type {PointAddress} from 'src/shared/types'

const fromSuggestObjectGet = makeGet<Optional<SuggestObject>>()

const _fromSuggestToPointAddress = (
  suggestObject: Optional<SuggestObject>,
): PointAddress => ({
  coordinates: pipe(suggestObject, fromSuggestObjectGet('position')),
  building: pipe(
    suggestObject,
    fromSuggestObjectGet('house'),
    toDefaultEmptyString,
  ),
  city: pipe(suggestObject, fromSuggestObjectGet('city'), toDefaultEmptyString),
  comment: pipe(suggestObject, fromSuggestObjectGet('comment')),
  country: pipe(suggestObject, fromSuggestObjectGet('country')),
  doorCode: pipe(
    suggestObject,
    fromSuggestObjectGet('doorPhoneNumber'),
    toDefaultEmptyString,
  ),
  flat: pipe(
    suggestObject,
    fromSuggestObjectGet('quartersNumber'),
    toDefaultEmptyString,
  ),
  floor: pipe(
    suggestObject,
    fromSuggestObjectGet('floorNumber'),
    toDefaultEmptyString,
  ),
  porch: pipe(
    suggestObject,
    fromSuggestObjectGet('porchnumber'),
    toDefaultEmptyString,
  ),
  shortName: pipe(
    suggestObject,
    fromSuggestObjectGet('title.text'),
    toDefaultEmptyString,
  ),
  street: pipe(suggestObject, fromSuggestObjectGet('street')),
  uri: pipe(suggestObject, fromSuggestObjectGet('uri')),
  log: pipe(suggestObject, fromSuggestObjectGet('log')),
})

const getAddressName: (suggestObject: Optional<SuggestObject>) => string = flow(
  firstOf(fromSuggestObjectGet('title.text'), fromSuggestObjectGet('text')),
  toDefaultEmptyString,
)

export const fromSuggestToPointAddress = (
  suggestObject: Optional<SuggestObject>,
): PointAddress => {
  // В Suggest подмешаны сохраненные пользователем адреса. Для таких адресов актуальный адрес хранится в subtitle.text
  const fullName = fromSuggestObjectGet('isSavedAddress', suggestObject)
    ? pipe(
        suggestObject,
        fromSuggestObjectGet('subtitle.text'),
        toDefaultEmptyString,
      )
    : pipe(suggestObject, getAddressName)

  return merge(_fromSuggestToPointAddress(suggestObject), {
    fullName,
  })
}
